import { getWidget } from '@uvocore-front/utils';
import htmlTemplate from './htmlTemplate';

function renderLCP(orders) {
  const ordersHtml = orders.map((item, index) => htmlTemplate(item, index));

  orders.forEach((order, key) => {
    const bullet = document.createElement('button');
    bullet.classList.add('glide__bullet');
    bullet.setAttribute('data-glide-dir', `=${key}`);
    document.querySelector('[data-bullets="lcp"]').appendChild(bullet);
  });

  document.querySelector('.latest-orders').innerHTML = ordersHtml.join('');
}

const initLCP = (callback = () => {}) => {
  getWidget({
    widgetLink: '/assets/js/lcp.js',
    loader: false,
    fn: () => {
      new LCP({/*eslint-disable-line */
        ID: '61',
        format: 'json',
        template: 'div',
        limit: 10,
        fields: [
          'paperType',
          'topicTitle',
          'discipline',
          'academicLevel',
          'pages',
          'delivered',
          'orderPrice',
        ],
        callback() {
          const data = this.options.json;
          renderLCP(data);

          callback();
        },
      });
    },
  });
};

export default initLCP;
